'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { CtaButtonStoryblok } from '@qogita/cms'

import { LinkButton } from '../components/primitives/link-button'
import { useGetCta } from '../hooks/use-get-cta'

function getVariant(style: CtaButtonStoryblok['style']) {
  switch (style) {
    case 'outlined':
      return 'outlined'
    case 'white':
      return 'white'
    default:
      return 'contained'
  }
}

export function CtaButton({ blok }: { blok: CtaButtonStoryblok }) {
  const { label, href, openNewTab } = useGetCta(blok)

  return (
    <LinkButton
      href={href}
      openNewTab={openNewTab}
      variant={getVariant(blok.style)}
      className="block md:inline-flex"
    >
      {label}
    </LinkButton>
  )
}
